/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-05 10:41:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-03-06 16:41:57
 */
import {LayoutIndex} from "@/routers/constant";
import {RouteObject} from "@/routers/interface";
import Home from "@/pages/home/index";
import MenuIcon from "@/routers/menu_icon";
import icon from "@/assets/icons/menu/首页.png";
import {Trans} from "react-i18next";


// 首页模块
const homeRouter: Array<RouteObject> = [
	{
		path: "/home",
		element: <LayoutIndex/>,
		icon: <MenuIcon src={icon}/>,
		meta: {
			title: 'Home',
		},
		children: [
			{
				path: "/home/index",
				element: <Home/>,
				meta: {
					title: "Home",
					key: "home",
					requiresAuth: true,
				},
			}
		]
	}
];

export default homeRouter;
